export const MentorshipEndpoints = {
    getMentorship: (mentorshipId) => {
        return `${process.env.API_CLUB_CONTENT}/${mentorshipId}`;
    },
    createMentorship: () => {
        return `${process.env.API_CLUB_CONTENT}/`;
    },
    updateMentorship: (mentorshipId) => {
        return `${process.env.API_CLUB_CONTENT}/${mentorshipId}`;
    }
};
